import db from "@/plugins/dexie";
import moment from "moment-timezone";
import { CHECKLIST_DIAS_JANELA } from "@/constants/CHECKLIST";

// TTL local do checklist (roda também offline). Nunca apaga formulário com envio na fila.
export default async function $_limpaFormularioLocal() {
  const limite = moment().subtract(CHECKLIST_DIAS_JANELA, 'days').format('YYYY-MM-DD');

  const formularios = await db.formulario.toArray();

  const envios = await db.formularioenvio.toArray();
  const protegidos = new Set(envios.map((envio) => envio.fenidformulario));

  const expirados = formularios.filter((formulario) => {
    if (protegidos.has(formulario.foridnuvem)) return false;

    // fordatacadastro é varchar: compara só o dia.
    const cadastro = String(formulario.fordatacadastro ?? '').substring(0, 10);
    if (!cadastro) return false;

    return cadastro < limite;
  });

  if (!expirados.length) return 0;

  const idsFormulario = expirados.map((formulario) => formulario.foridnuvem);

  await db.transaction(
    'rw',
    db.formulario,
    db.formularioquestao,
    db.formularioquestaoopcao,
    db.formularioidentificacao,
    db.formularioresposta,
    async () => {
      const questoes = await db.formularioquestao
        .where('foqidformularionuvem')
        .anyOf(idsFormulario)
        .toArray();

      const identificacoes = await db.formularioidentificacao
        .where('foridformulario')
        .anyOf(idsFormulario)
        .toArray();

      const idsQuestao = questoes.map((questao) => questao.foqidnuvem);
      const idsIdentificacao = identificacoes.map((ident) => ident.foiidnuvem);

      if (idsIdentificacao.length) {
        await db.formularioresposta
          .where('frsidformularioidentificacao')
          .anyOf(idsIdentificacao)
          .delete();
      }

      if (idsQuestao.length) {
        await db.formularioquestaoopcao
          .where('fqoidformularioquestaonuvem')
          .anyOf(idsQuestao)
          .delete();
      }

      await db.formularioidentificacao.where('foridformulario').anyOf(idsFormulario).delete();
      await db.formularioquestao.where('foqidformularionuvem').anyOf(idsFormulario).delete();
      await db.formulario.where('foridnuvem').anyOf(idsFormulario).delete();
    },
  );

  console.log(`[CHECKLIST] TTL local: ${expirados.length} formulário(s) removido(s)`);

  return expirados.length;
}
